// extracted by mini-css-extract-plugin
export default {"navsub":"TraCuuPage_navsub__Dmspi"};